var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 553,
    viewBox: "0 0 619 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_12_160",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.978 94.6744C527.532 32.9934 419.704 0.123471 309.4 0.303936C199.096 0.484401 91.3765 33.707 0.132921 95.6869L310.303 552.303L618.978 94.6744Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M618.978 94.6744C527.532 32.9934 419.704 0.123471 309.4 0.303936C199.096 0.484401 91.3765 33.707 0.132921 95.6869L310.303 552.303L618.978 94.6744Z",
    fill: "url(#paint0_linear_12_160)",
    stroke: "#D4F9DE",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_12_160)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_160",
    x1: 310,
    y1: 29.5,
    x2: 310,
    y2: 989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8B44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlow);
export default __webpack_public_path__ + "static/media/glow.948e3b20c2f3ff9e1f06aef911a98174.svg";
export { ForwardRef as ReactComponent };